(function () {
  'use strict';
  /* eslint-disable */
  angular.module('sempraWebapp').config(['$provide', Decorate]);
  /* eslint-enable */

  /** @ngInject */
  function Decorate($provide) {
    $provide.decorator('uibDaypickerDirective', function ($delegate) {
      var directive = $delegate[0];
      directive.templateUrl = "app/components/dateTimePicker/day.html";
      return $delegate;
    });
    $provide.decorator('uibMonthpickerDirective', function ($delegate) {
      var directive = $delegate[0];
      directive.templateUrl = "app/components/dateTimePicker/month.html";
      return $delegate;
    });
    $provide.decorator('uibYearpickerDirective', function ($delegate) {
      var directive = $delegate[0];
      directive.templateUrl = "app/components/dateTimePicker/year.html";
      return $delegate;
    });
  }

})();